import {
  autoGeneratedExternalCodes,
  authorizedRolesToUpdateSeller,
} from 'Utils/constants'

/**
 * Returns an updated quote object with a new seller if specific conditions are met.
 *
 * Conditions for updating the seller:
 * - The quote was auto-generated (e.g. by Chat Bot or Web Documents), AND
 * - The quote is being edited for the first time (IsEdited), AND
 * - The current user has a role authorized to update the seller.
 *
 * If all conditions are met:
 * - The seller (SalesAgentId and SalesAgentFullName) is updated with the current user's info.
 *
 * For all other cases:
 * - The quote is returned unchanged (no update to the seller).
 *
 * @param {Object} quote - The quote object being edited.
 * @param {Array} userRoles - Array of roles associated with the current user.
 * @param {Object} currentUser - The current user performing the edit.
 * @returns {Object} - The updated quote object, or the original if no update is needed.
 */
export function updateSellerIfApplicable(quote, userRoles, currentUser) {
  const ivendUserCode = quote.QuoteHeader.SalesAgentExternalCodes?.find(
    code => code.ExternalSystem?.toLowerCase() === 'ivend user'.toLowerCase()
  )?.ExternalCode

  const isAutoGenerated = ivendUserCode
    ? autoGeneratedExternalCodes.includes(ivendUserCode)
    : false
  const isEdited = quote.QuoteHeader?.IsEdited
  const hasAuthorizedPermission = userRoles.some(role =>
    authorizedRolesToUpdateSeller.includes(role.RoleName)
  )

  if (isEdited || !isAutoGenerated || !hasAuthorizedPermission) {
    return quote
  }

  return {
    ...quote,
    QuoteHeader: {
      ...quote.QuoteHeader,
      SalesAgentId: currentUser.CustomerId,
      SalesAgentFullName: currentUser.FullName,
    },
  }
}
